import {Table} from 'react-bootstrap';
import { useSortableTable, SortableTh } from '../SortableTable';
import { formatDateTime } from '../../utils/dateFormat';

const LOG_SORT_COLUMNS = {
    when: { type: 'date', value: (l) => l?.createdAt },
    detail: { type: 'string', value: (l) => l?.text },
    role: { type: 'string', value: (l) => (l?.doctor_id || l?.hr_id || l?.admin_id || l?.created_by || {}).role },
};

const PatientLogType = ({logs} ) => {
  const tableSort = useSortableTable(logs, { id: 'logs.PatientLogType', columns: LOG_SORT_COLUMNS, defaultSort: { key: 'when', dir: 'desc' } });
  return (
    <div>
        <Table striped hover bordered>
            <thead align="center">
                <tr>
                    <th>Patient Details</th>
                    <th>Email Address</th>
                    <SortableTh sortKey="detail" sort={tableSort}>Log Detail</SortableTh>
                    <th>Log Type</th>
                    <SortableTh sortKey="when" sort={tableSort}>Date & Time</SortableTh>
                </tr> 
            </thead>
            <tbody>
            {tableSort.rows.map((log, index) => (
            <tr key={index}>
                    <td>{log?.patient_id?.firstname} {log?.patient_id?.lastname}
                        <p style={{color: 'gray'}}>{log?.patient_id?.gender}</p>
                    </td>
                    <td style={{wordWrap: 'break-word'}}>{log?.patient_id?.email}</td>
                    <td>{log?.text}</td>
                    <td>Patient Profile</td>
                    <td>{formatDateTime(log?.createdAt)}</td>
            </tr>
            ))}
            </tbody>
        </Table>
    </div>
  )
}

export default PatientLogType